export default "__VITE_ASSET__D3UsG7bz__"